var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showElement
    ? _c(
        "div",
        { staticClass: "compare-row margin-bottom-xs tablet:margin-bottom-0" },
        [
          _c(
            "dl",
            { staticClass: "row roomy padding-x-2xs" },
            [
              _c("table-feature-name", {
                attrs: {
                  "feature-name": _vm.featureName,
                  "feature-description": _vm.featureDescription,
                  "feature-icon": _vm.featureIcon,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "column-12 tablet:column-9 laptop:column-10 display-flex padding-x-2xs tablet:padding-x-sm",
                },
                _vm._l(_vm.plansBySku, function (sku) {
                  return _c("table-feature-status", {
                    key: sku,
                    attrs: {
                      plan: _vm.planBySku(sku),
                      "handle-function": _vm.handleFunction,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }